import { IController } from 'angular';
import * as _ from 'lodash';

import { RegentsExam } from '../../../../../../../../ng2/shared/constants/regents.constant';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';

interface IMismatchByStudent {
  _id: string;
  studentId: string;
  mismatchedExams: string[]; // student _ids
}

export class StarsMismatchTransferCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public filteredStudents; // modified students
  public studentsWithMismatches;
  public mismatchedExamsByStudent: IMismatchByStudent[];
  public mismatchedExamsByExamShortName;
  public totalMismatchedExams: number;
  public patches;
  public options;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.mismatchedExamsByStudent = this.generateMismatchedExamData();
    this.studentsWithMismatches = _.map(this.mismatchedExamsByStudent, ({ studentId }) => studentId);
    this.mismatchedExamsByExamShortName = this.organizeMismatchedExamsByExamShortName();
    this.totalMismatchedExams = this.WizardUtils.getCountOfStudentsToBePatched(this.mismatchedExamsByExamShortName);
    this.patches = this.WizardUtils.getRegentsExamBulkPatch(this.mismatchedExamsByExamShortName, 'shortName');
    this.options = {
      columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate', 'examsSchedInStarsNotPlannedInPortal'],
    };
  }

  private generateMismatchedExamData(): IMismatchByStudent[] {
    return _.reduce(
      this.filteredStudents,
      (result, { _id, studentId, examsSchedInStarsNotPlannedInPortal: mismatchedExams }) => {
        if (mismatchedExams.length) result.push({ _id, studentId, mismatchedExams });
        return result;
      },
      [],
    );
  }

  private organizeMismatchedExamsByExamShortName() {
    const baseObj = _.reduce(
      RegentsExam,
      (result, exam) => {
        // obj key must be based on shortName: returned from sorterCol
        if (exam && exam.key) result[exam.shortName] = { _ids: [], studentIds: [] };
        return result;
      },
      {},
    );
    _.each(this.mismatchedExamsByStudent, ({ _id, studentId, mismatchedExams }) => {
      _.each(mismatchedExams, examShortName => {
        if (baseObj[examShortName]) {
          baseObj[examShortName]._ids.push(_id);
          baseObj[examShortName].studentIds.push(studentId);
        }
      });
    });
    return baseObj;
  }
}
